<template>
  <div class="container-fluid">
    <template v-if="isCreated">
      <occupational-consult-note-print
        v-if="selectedConsultNote.mainForm.templateId !== 'T3'"
        :selectedPatient="selectedPatient"
        :selectedConsultNote="selectedConsultNote"
      />
      <premium-occupational-consult-note-print
        v-else
        :selectedPatient="selectedPatient"
        :selectedConsultNote="selectedConsultNote"/>
    </template>
  </div>
</template>

<script>
import OccupationalConsultNotePrint from '@/components/Print/OccupationalConsultNotePrint.vue';
import PremiumOccupationalConsultNotePrint from '@/components/Print/PremiumOccupationalConsultNotePrint.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'OccupationalPatientConsultNote',
  components: {
    OccupationalConsultNotePrint,
    PremiumOccupationalConsultNotePrint
  },
  data() {
    return {
      isCreated: false,
      selectedConsultNote: {},
    };
  },
  computed: {
    ...mapGetters('patient', ['selectedPatient']),
    ...mapGetters('config', ['general', 'patient']),
  },
  async created() {
    const vm = this;
    let vuex = await window.store.getters.vuex.storage.getItem('vuex');
    if (typeof vuex !== 'object') {
      vuex = JSON.parse(vuex);
    }
    vm.selectedConsultNote = Object.assign({}, vuex.note.print); /* eslint-disable-line no-restricted-globals */
    this.isCreated = true;
  },
};
</script>
